import { GtmTracker } from '@/modules/common/services/analytics';
import { Categories } from '@/types/models/Analytics';

const trackEvent = GtmTracker.trackerWithDefaultProps({
  category: Categories.PEX
});

const trackAmplitudeEventPortfolio = GtmTracker.trackerWithDefaultProps({
  digital_experience: 'investor',
  experience_section: 'portfolio'
});

export function cardCta() {
  trackEvent({
    action: 'Clique ver agora',
    label: 'Nova sugestao de investimento'
  });
}

export function cardCtaAmplitude() {
  trackAmplitudeEventPortfolio({
    page_screen: 'home_overview',
    event_type: 'click',
    page_screen_section: 'news',
    event_name: 'view_investment_suggestion',
    event_target: 'Ver Agora'
  });
}
